<template>
  <el-drawer class="drawer-rigth-menu" :visible.sync="drawer" direction="rtl" :size="sizeRM" :destroy-on-close="true"
    :append-to-body="true" :wrapperClosable="false" @close="close()">
    <header-component slot="title" class="pruebaAncho" :data="rightMenu.data" @back="close()" />
    <transition-group name="fade">
      <component :is="rightMenu.componentActive" :payload="rightMenu.data" key="component"></component>
    </transition-group>
    <footer-component class="footer-component" key="footer" :edit="rightMenu.data.edit" :table="rightMenu.data.table"
      v-if="!rightMenu.data.btnRemove" />
  </el-drawer>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import FooterComponent from "./Footer";
import HeaderComponent from "./Header";
export default {
  components: { FooterComponent, HeaderComponent },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['rightMenu']),
    drawer: {
      get() { return this.rightMenu.drawer },
      set(value) { this.setRightMenuDrawer(value) }
    },
    sizeRM: function () {
      this.innerWidth = window.innerWidth;
      if (window.innerWidth <= 415) {
        return '99%'
      } else {
        if (window.innerWidth <= 768) {
          return '80%'
        } else {
          if (window.innerWidth <= 840) {
            return '60%'
          } else {
            if (window.innerWidth <= 1024) {
              return '50%'
            } else {
              if (window.innerWidth <= 1260) {
                return '40%'
              } else {
                return this.rightMenu.data.fullscreen ? '100%' : '30%'
              }
            }
          }
        }
      }
    }
  },
  methods: {
    ...mapMutations(['setRightMenu', 'setRightMenuDrawer']),
    close() {
      this.setRightMenu({
        componentActive: '',
        drawer: false,
        data: {
          icon: '',
          title: '',
          btnRemove: false,
        }
      })
    },
  },
};
</script>
<style lang="scss">
.drawer-rigth-menu {
  .el-drawer__body {
    // margin-top: 80px;
    margin-bottom: 80px;
    padding-left: 20px;
    padding-right: 20px;
  }

  .el-drawer {
    overflow: auto !important;
  }

  .el-drawer__header {
    margin-bottom: 0px;
    padding-top: 5px !important;
    padding-bottom: 5px !important;
    background-color: #5f8fdf !important;
    color: white;
    position: sticky;
    top: 0;
    // width: 28%;
    margin-right: 0px;
    margin-left: 0px;
    z-index: 999;
  }

  .el-page-header__content {
    color: white !important;
  }

}
</style>
